// Whether a name is free while it is typed: the cash sign-up's nickname and a visitor's keke name
// on the way in (a nickname is one player's; nobody else drives under it).
import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * Whether the nickname being typed is free, asked once the typing pauses. Null while it is short,
 * unchanged or not yet answered; a failed ask says nothing (the sign-up checks again on send).
 */
export function useNicknameCheck(typed: string, min = 3): { free: boolean; reason?: string } | null {
  const [answer, setAnswer] = useState<{ name: string; free: boolean; reason?: string } | null>(null);
  const name = typed.trim();
  useEffect(() => {
    if (name.length < min) return;
    let live = true;
    const t = setTimeout(() => {
      api
        .nicknameFree(name)
        .then((r) => live && setAnswer({ ...r, name }))
        .catch(() => undefined);
    }, 400);
    return () => {
      live = false;
      clearTimeout(t);
    };
  }, [name, min]);
  return answer && answer.name === name && name.length >= min ? answer : null;
}
